import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import { CHANGE_USER_COUNTRIES_FAILED, CHANGE_USER_COUNTRIES_SUCCESS, GET_SUB_USERS_LIST_FAILED, GET_SUB_USERS_LIST_SUCCESS } from "../Actions/UserManagementActions";
import { TOAST_SHOW } from "../Actions/ToastAction";

export function* getSubUsersListSaga(action: any): unknown {
    try {
        const response = yield call(axios.get, 'getSubUsers');
        const { data, status } = response;

        if(status === 200){
            yield put({type: GET_SUB_USERS_LIST_SUCCESS, payload: data });
        }
        } catch (error) {
            yield put({ type: GET_SUB_USERS_LIST_FAILED, payload: false });
        }
    }

export function* changeUserCountriesSaga(action: any):unknown{
    try { 
    const restData = action.payload
    const response = yield call(axios.post, `changeUserCountries`, restData);
    const { status } = response

        if (status === 200) {
            yield put({ type: CHANGE_USER_COUNTRIES_SUCCESS });
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'Saved Successfully!', severity: 'Success', show: true },
            });
        }

    } catch (e: any) {
        yield put({ type: CHANGE_USER_COUNTRIES_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}
